
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import SopasScreen from './sopas';
import BebidasFriasScreen from './bebidasfrias';
import PolloBrasaScreen from './pollobrasa';
import CriollosScreen from './criollos';
import DesayunosScreen from './desayunos';
import BebidasCalientesScreen from './bebidascalientes';
import VegetarianosScreen from './vegetarianos';
import ChaufasScreen from './chaufas';
import SaltadosScreen from './saltados';
import CevicheScreen from './ceviche';
import SepecialMariscosScreen from './sepecialMariscos';
import TallarinesScreen from './tallarines';

function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showSopas, setshowSopas] = useState(false);
    const [showBebidasFrias, setshowBebidasFrias] = useState(false);
    const [showPolloBrasa, setshowPolloBrasa] = useState(false);
    const [showCriollos, setshowCriollos] = useState(false);
    const [showDesayunos, setshowDesayunos] = useState(false);
    const [showBebidasCalientes, setshowBebidasCalientes] = useState(false);
    const [showVegetarianos, setshowVegetarianos] = useState(false);
    const [showChaufas, setshowChaufas] = useState(false);
    const [showSaltados, setshowSaltados] = useState(false);
    const [showCeviche, setshowCeviche] = useState(false);
    const [showSepecialMariscos, setshowSepecialMariscos] = useState(false);
    const [showTallarines, setshowTallarines] = useState(false);
        useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);

    
     const fetchImage = async (id) => {
            const imageBlob = await getImage(id);
            if (imageBlob) {
                const imageURL = URL.createObjectURL(imageBlob.data.blob);
                return imageURL;
            }
            return null;
     };
    
    const Item = (props) => {
        const { item } = props;
        const [image, setImage] = useState(false);
                useEffect(() => {
                    fetchImage(`menu-cat-${item.id}`).then((url) => {
                        if (url) {
                            setImage(url);
                            
                        }
                    });
                }, []);
        
        return <div  style={{
                                display: 'flex',
                                alignItems: "center",
                                justifyContent: 'center',
                                width: 340,
            position: "relative",
            marginBottom: 5,
                                
                            }}
            onClick={() => { 
                                    
                if(item.id === 514) {
                    setshowSopas(true)
                } else if(item.id === 509) {
                    setshowBebidasFrias(true)
                } else if(item.id === 513) {
                    setshowPolloBrasa(true)
                } else if(item.id === 504) {
                    setshowCriollos(true)
                } else if(item.id === 506) {
                    setshowDesayunos(true)
                } else if(item.id === 516) {
                    setshowBebidasCalientes(true)
                } else if(item.id === 508) {
                    setshowVegetarianos(true)
                } else if(item.id === 454) {
                    setshowChaufas(true)
                } else if(item.id === 510) {
                    setshowSaltados(true)
                } else if(item.id === 512) {
                    setshowCeviche(true)
                } else if(item.id === 511) {
                    setshowSepecialMariscos(true)
                } else if(item.id === 456) {
                    setshowTallarines(true)
                } else {
                    setShowListProduct(true)
                    setdishs(item)
                }
            }}
                                >
                                    <div
                                        style={{
                                            marginTop: 10,
                                            width: '100%',
                                            height: 170,
                                            borderRadius: 24,
                                            backgroundColor: '#6F6F6F',
                                            position: 'relative',
                                            boxShadow: '0 6px 0 rgba(0,0,0,0.35)',
                                        cursor: 'pointer',
                                    padding: 20,
                                            
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 12,
                                                bottom: 12,
                                                left: 12,
                                                right: 12,
                                                borderRadius: 18,
                                                boxShadow: 'inset 0 0 0 3px #FFFFFF'
                                            }}
                                        />
                                        {/* fontFamily: 'WallAxe', */}
                                        <p
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: 0,
                                                color: 'white',
                                                fontWeight: '500',
                                                textTransform: 'uppercase',
                        letterSpacing: 1,
                                                fontFamily: 'BebasNeue',
                        fontSize: 32,
                                                paddingHorizontal: 10,
                                            }}
                                        >
                                            {item.name}
                                        </p>
                                    </div>

                            </div>
                            
    }
    return (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999 }}>
            <LayoutContent showLamp={ false} showBack={true} showImageTop={false}  setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={setShowSpecials}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 785}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                        {menus.map((item, key) => {
                            if (![443, 444, 445, 594, 446, 447, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567, 597].includes(item.id)) {
                                return <Item item={item} key={key} />
                            }
                            
                        })}
                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}
                {showSopas && <SopasScreen setShowBuffet={setshowSopas} />}
                {showBebidasFrias && <BebidasFriasScreen setShowBuffet={setshowBebidasFrias} />}
                {showPolloBrasa && <PolloBrasaScreen setShowBuffet={setshowPolloBrasa} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                {showCriollos && <CriollosScreen setShowBuffet={setshowCriollos} />}
                {showDesayunos && <DesayunosScreen setShowBuffet={setshowDesayunos} />}
                {showBebidasCalientes && <BebidasCalientesScreen setShowBuffet={setshowBebidasCalientes} />}
                {showVegetarianos && <VegetarianosScreen setShowBuffet={setshowVegetarianos} />}
                {showChaufas && <ChaufasScreen setShowBuffet={setshowChaufas} />}
                {showSaltados && <SaltadosScreen setShowBuffet={setshowSaltados} />}
                {showCeviche && <CevicheScreen setShowBuffet={setshowCeviche} />}
                {showSepecialMariscos && <SepecialMariscosScreen setShowBuffet={setshowSepecialMariscos} />}
                {showTallarines && <TallarinesScreen setShowBuffet={setshowTallarines} />}
            </LayoutContent>
        </div>
    );
}
export default Index;